import api from './axios';
import { BannerSlide } from '../types/bannerSlides';

export const getBannerSlides = async (language?: string): Promise<BannerSlide[]> => {
  const params = language ? { language } : {};
  const response = await api.get<BannerSlide[]>('/api/banner-slides', { params });
  return response.data;
}; 